import { render } from "./AdminRateCreate.vue?vue&type=template&id=0658b1a5&scoped=true&ts=true&lang=true"
import script from "./AdminRateCreate.vue?vue&type=script&lang=ts"
export * from "./AdminRateCreate.vue?vue&type=script&lang=ts"

import "./AdminRateCreate.vue?vue&type=style&index=0&id=0658b1a5&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0658b1a5"]])

export default __exports__